'use strict';

export const roundSvsScore = score => {
    if (typeof score === 'number') {
        return Math.round(score);
    }

    return score;
};
